// score is the number of correct answers.
export type Entry = { name: string; score: number; at: number };

// null marks a "…" gap between shown ranks.
export type Row = { rank: number; entry: Entry } | null;

const STORAGE_KEY = "quiz-leaderboard";

export const normalizeName = (name: string) =>
  name.trim().replace(/\s+/g, " ").toLowerCase();

export function loadEntries(): Entry[] {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) ?? "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    console.warn("Classificação inválida no localStorage para o Quiz");
    return [];
  }
}

export function saveEntries(entries: Entry[]) {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
}

// Highest score first; ties go to whoever finished first.
export const rankEntries = (entries: Entry[]) =>
  [...entries].sort((a, b) => b.score - a.score || a.at - b.at);

// With a player: top 3, then the player's rank ±1, with gaps in between.
// Without a player: top 10.
export function leaderboardRows(entries: Entry[], playerName?: string): Row[] {
  const ranked = rankEntries(entries);
  const player = playerName
    ? ranked.findIndex((e) => normalizeName(e.name) === normalizeName(playerName))
    : -1;
  const isShown = (i: number) =>
    player < 0 ? i < 10 : i < 3 || Math.abs(i - player) <= 1;

  const rows: Row[] = [];
  ranked.forEach((entry, i) => {
    if (isShown(i)) rows.push({ rank: i + 1, entry });
    else if (rows[rows.length - 1] !== null) rows.push(null);
  });
  return rows;
}
